import React, { useEffect } from 'react';
import styles from './Modal.module.css'
import cx from "classnames";
import {useGlobalContext} from "../../contexts/globalContext";

const Modal: React.FC = () => {

    const {modal, closeModal} = useGlobalContext()
    useEffect(() => {
        if (modal.visible) document.querySelector('html')?.classList.add('zr-overflow-hidden')
        else document.querySelector('html')?.classList.remove('zr-overflow-hidden')
    }, [modal])

    return modal.visible ? (
        <div className={cx(styles['zr-modal-overlay'])}>
            <div className={modal.size==='lg' ? cx(styles['zr-modal-content-lg']) : cx(styles['zr-modal-content'])} style={{width: modal.width ?? ''}}>
                <button className={cx(styles['zr-close-button'])} onClick={() => closeModal()}>
                    &times;
                </button>
                {modal.heading && (
                    <div className={cx(styles['zr-modal-header'])}>
                        {modal.heading}
                    </div>
                )}
                {modal.content}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default Modal;
